import { backendApi } from "../dynamicBAseQuery";

export const PaymentsApi=backendApi.injectEndpoints({
    overrideExisting:true,
    endpoints:(builder)=>({
        allBusinessAssociatePaymentList:builder.mutation({
            query:(args)=>({
                method:'POST',
                url:'getAllBusinessAssociatePaymentsList',
                body:{...args}
            })
        }),

    })
})
export const {
    useAllBusinessAssociatePaymentListMutation,
}=PaymentsApi